export default function initNavigation() {
  // close annoucement bars
  jQuery('#close-announcement-bar').on('click', function () {
    jQuery(this).closest('.notification-bar').attr('aria-hidden', 'true').slideUp().removeClass('opened');
  });

  // hamburger menu button
  jQuery('.mobile-button').on('click', function () {
    const $button = jQuery(this);
    const $nav = jQuery('.site-header__nav');
    const isOpen = !$nav.hasClass('opened');

    $button.toggleClass('close-nav');
    $button.attr('aria-expanded', isOpen ? 'true' : 'false');
    $nav.toggleClass('opened').attr('aria-hidden', isOpen ? 'false' : 'true');
  });

  jQuery('.menu-item-has-children > a').on('click', function (e) {
    e.preventDefault();
    const $trigger = jQuery(this);
    const $submenu = $trigger.next('.sub-menu');
    const isOpen = !$submenu.hasClass('sub-opened');

    $submenu.toggleClass('sub-opened').attr('aria-hidden', isOpen ? 'false' : 'true');
    $trigger.toggleClass('sub-opened-parent').attr('aria-expanded', isOpen ? 'true' : 'false');
  });

  if (document.body.classList.contains('home')) {
    window.addEventListener('scroll', function () {
      const scrolled = window.scrollY;
      const screenHeight = window.innerHeight;
      if (scrolled > screenHeight * 0.5) {
        document.querySelector('.site-header__container').classList.remove('site-header__home');
      } else {
        document.querySelector('.site-header__container').classList.add('site-header__home');
      }
    });
  }
}
